import { Spin } from "antd";
import { useState } from "react";
import { loadingContext } from "../../contexts/LoadingContext";

function LoadingIndicator(props) {
  const [loading, setLoading] = useState(false);

  const update = (isLoading) => {
    setLoading(isLoading);
  };

  return (
    <loadingContext.Provider
      value={{ loading: loading, updateLoadingIndicator: update }}
    >
      <Spin size="large" spinning={loading}>
        {props.children}
      </Spin>
    </loadingContext.Provider>
  );
}

export default LoadingIndicator;
